import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

export const LoaderIcon = () => (
  <Spinner animation="border" variant="primary" />
);

interface LoaderProps {
  isModal?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ isModal = false }) => (isModal ? (
  <Modal show centered contentClassName="bg-transparent border-0">
    <Modal.Body className="text-center">
      <LoaderIcon />
    </Modal.Body>
  </Modal>
) : (
  <div className="d-flex flex-grow-1 justify-content-center align-items-center">
    <LoaderIcon />
  </div>
));

export default Loader;
